/** @format */

import { TOGGLE_ADD_ACTIVITY_MODAL } from "./AddActivityModalTypes";

export const toggleAddActivityModal = () => {
  return {
    type: TOGGLE_ADD_ACTIVITY_MODAL,
  };
};
